import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {ToasterService, ToasterConfig} from "angular2-toaster/angular2-toaster";
import {TranslateService} from "ng2-translate/index";

@Component({
    selector: 'import-widget',
    templateUrl: './import-widget.component.html',
    styleUrls: ['./import-widget.component.scss']
})
export class ImportWidgetComponent implements OnInit {

    @Input() lastResponse: any; // TODO - Declare properly the structure of the importing response
    @Input() uploading: boolean;

    @Output()
    fileChanged: EventEmitter<File> = new EventEmitter<File>();

    private toasterconfig: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-bottom-right',
        showCloseButton: false,
        timeout: 0,
        preventDuplicates: true,
        newestOnTop: true
    });

    constructor(
        private toasterService: ToasterService,
        private translate: TranslateService,
    ) { }

    ngOnInit() {
    }

    popToast(type, title, text, params) {
        params = params || {};
        this.translate.get([text, title], params).toPromise()
            .then(res => {
                this.toasterService.pop(type, res[title], res[text]);
            });
    }

    public extensionValidator(fileName, extensions){
        let extension = fileName.name.split('.').pop();
        return extensions.find(element => extension == element)
    }

    public onImportFileChange(event, image) {
        let fileList: FileList = event.srcElement ? event.srcElement.files : event.target.files;

        if(fileList.length > 0) {

            let file: File = fileList[0];

            if (! this.extensionValidator(file, ['csv'])){
                this.popToast('error', 'files.TOAST.TITLE_NOK', 'files.TOAST.ERROR', null);
                return;
            }

            this.fileChanged.emit(file);
        }
    }

    public onImportFileClick(event, input) {
        input.value = "";
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/common/import-widget/import-widget.component.ts